<template>
  <div>
    <!-- Avatar & Greetings -->
    <div class="d-flex d-lg-none align-items-center justify-content-between mb-2">
      <div class="d-flex gap-2 align-items-center">
        <img src="https://cdn.efunding.id/images/wajahilustrat.png" style="width: 35px;" />
        <span>Hallo, <b>{{ user.info.name }}</b></span>
      </div>
      <b-icon v-b-toggle.sidebar-menu icon="list" style="font-size: 1.5rem;"></b-icon>
    </div>

    <!-- Collapse Menu Mobile -->
    <b-collapse id="sidebar-menu">
      <div v-for="menu in menus" :key="menu.label" class="mb-2">
        <b-button
          block
          :pressed="selectedTab === menu.component"
          class="btn btn-custom theme-color text-white"
          @click="!menu.disable && handleClick(menu)"
          :disabled="menu.disable"
        >
          {{ menu.label }}
          <b-icon
            v-if="menu.children"
            :icon="isExpanded(menu.label) ? 'chevron-up' : 'chevron-down'"
            class="float-right"
          ></b-icon>
        </b-button>

        <!-- Submenu Mobile -->
        <transition name="slide-fade">
          <div v-if="isExpanded(menu.label)">
            <b-button
              v-for="child in menu.children || []"
              :key="child.label"
              block
              class="btn btn-custom theme-color text-white text-left"
              style="padding-left: 2rem;"
              :pressed="selectedTab === child.component"
              @click="!child.disable && handleClick(child)"
              :disabled="child.disable"
            >
              {{ child.label }}
            </b-button>
          </div>
        </transition>
      </div>

      <!-- Tombol Generate Link (Mobile) -->
      <div v-if="hasGenerateLink" class="mt-3">
        <b-button
          block
          class="btn-generate-link"
          :disabled="loadingGenerate"
          @click="handleGenerateLink"
        >
          <b-spinner small v-if="loadingGenerate" label="Loading..."></b-spinner>
          <template v-else>
            <b-icon icon="link-45deg" class="me-1"></b-icon>
            Generate Link
          </template>
        </b-button>
      </div>
    </b-collapse>

    <!-- Sidebar Desktop -->
    <div class="d-none d-lg-block">
      <div class="text-center mb-3 profile-text">
        <img :src="avatarImage" class="img-fluid rounded-circle mb-2" width="150" />
        <p>
          Hallo, <b>{{ user.info.name }}</b><br />
          <small>{{ user.info.email }}<br />+{{ user.info.no_telpon }}</small>
        </p>
      </div>

      <div v-for="menu in menus" :key="menu.label" class="mb-2">
        <b-button
          block
          :pressed="selectedTab === menu.component"
          class="btn btn-custom theme-color"
          @click="!menu.disable && handleClick(menu)"
          :disabled="menu.disable"
        >
          {{ menu.label }}
          <b-icon
            v-if="menu.children"
            :icon="isExpanded(menu.label) ? 'chevron-up' : 'chevron-down'"
            class="float-right"
          ></b-icon>
        </b-button>

        <!-- Submenu Desktop -->
        <transition name="slide-fade">
          <div v-if="isExpanded(menu.label)">
            <b-button
              v-for="child in menu.children || []"
              :key="child.label"
              block
              class="btn-custom-sm mt-1"
              @click="!child.disable && handleClick(child)"
              :disabled="child.disable"
            >
              {{ child.label }}
            </b-button>
          </div>
        </transition>
      </div>

      <!-- Tombol Generate Link (Desktop) -->
      <div v-if="hasGenerateLink" class="mt-4 text-center">
        <b-button
          class="btn-generate-link"
          block
          :disabled="loadingGenerate"
          @click="handleGenerateLink"
        >
          <b-spinner small v-if="loadingGenerate" label="Loading..."></b-spinner>
          <template v-else>
            <b-icon icon="link-45deg" class="me-1"></b-icon>
            Buat Link Agen
          </template>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import avatarImage from "@/assets/images/wajahilustrat.png";

export default {
  data() {
    return {
      avatarImage,
    };
  },
  props: {
    menus: Array,
    selectedTab: String,
    expandedMenu: String,
    /** 
     * Apakah tombol generate link ditampilkan 
     * (true = tampil, false/null = disembunyikan)
     */
    hasGenerateLink: {
      type: Boolean,
      default: false,
    },
    /**
     * Loading state untuk tombol generate link
     */
    loadingGenerate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    handleClick(menu) {
      if (menu.children) {
        if (this.expandedMenu === menu.label) {
          this.$emit("toggle-expand", "");
        } else {
          this.$emit("toggle-expand", menu.label);
        }
      } else {
        if (menu.route) {
          this.$router.push(menu.route);
        } else {
          this.$emit("select", menu);
        }
      }
    },
    isExpanded(label) {
      return this.expandedMenu === label;
    },
    handleGenerateLink() {
      // emit hanya jika event terdaftar
      if (this.$listeners["generate-link"]) {
        this.$emit("generate-link");
      }
    },
  },
};
</script>

<style scoped>
.btn[disabled] {
  background-color: #c0c0c0 !important;
  color: #6c757d !important;
  cursor: not-allowed !important;
  border: none !important;
}

/* Tombol utama */
.btn-custom {
  background-color: #FFC107;
  color: #274c8f;
  border: none;
  border-radius: 8px;
  font-weight: 600;
}

.btn-custom:hover,
.btn-custom:focus {
  background-color: #274c8f !important;
  color: white !important;
}

.btn-custom.active,
.btn-custom:active,
.btn-custom[pressed="true"] {
  background-color: #274c8f !important;
  color: white !important;
}

/* Tombol submenu */
.btn-custom-sm {
  max-width: 200px;
  margin: auto;
  background-color: #FFC107;
  border: none;
  color: #274c8f;
  border-radius: 6px;
}

.btn-custom-sm:hover,
.btn-custom-sm:focus {
  background-color: #274c8f !important;
  color: white !important;
}

.btn-custom-sm.active,
.btn-custom-sm:active,
.btn-custom-sm[pressed="true"] {
  background-color: #274c8f !important;
  color: white !important;
}

/* Tombol generate link */
.btn-generate-link {
  background-color: #FFC107;
  color: #274c8f;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.btn-generate-link:hover {
  background-color: #274c8f !important;
  color: white !important;
}

/* Profile text */
.profile-text p {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 1.4;
}

.profile-text small {
  font-size: 11px;
  line-height: 1.3;
  word-break: break-word;
  display: inline-block;
}

/* Animasi slide fade */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.slide-fade-enter,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave {
  max-height: 500px;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/pengajuan-saya/SidebarMenu.vue